import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
// Define the initial state of the context
const initialValue = {
    environmentOptions: {
        searchApiBaseUrl: '',
        apiKey: '',
        application: 'aap',
        environment: 'development',
    },
    globalRestrictTo: undefined,
    accessFilters: undefined,
};
// Create the context
export const SourSearchAppContext = createContext(initialValue);
// Create a provider component
export const SourSearchAppProvider = ({ children, environmentOptions, globalRestrictTo, onGlobalOnSeeAllClick, accessFilters, }) => {
    const values = useMemo(() => ({
        environmentOptions,
        globalRestrictTo,
        onGlobalOnSeeAllClick,
        accessFilters,
    }), [globalRestrictTo, environmentOptions, accessFilters]);
    return _jsx(SourSearchAppContext.Provider, { value: values, children: children });
};
//# sourceMappingURL=app-context.js.map